module.exports = __webpack_public_path__ + "static/media/inktoberSweater.e83555c6.gif";